import { render, staticRenderFns } from "./rhAppointShot.vue?vue&type=template&id=cf5b1dca"
import script from "./rhAppointShot.vue?vue&type=script&lang=js"
export * from "./rhAppointShot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports